<template>
  <wrap-container>
    <h1 class="titulo titulo--principal p32 oscuro medium">
      Libro de Quejas Online
    </h1>
    <formulario-contacto />
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto.vue";

export default {
  name: "TipoProducto",
  components: {
    WrapContainer,
    FormularioContacto
  }
};
</script>

<style>
#mensajeAlert {
  background-color: #d5ecff;
  padding: 10px;
  line-height: 24px;
  display: flex;
  margin-bottom: 10px;
  margin-top: 20px;
  font-family: BentonSansBBVA-Book, Helvetica, Arial, sans-serif;
  font-size: 15px;
}

#mensajeAlert img {
  margin: 1px 16px 5px 0px;
}

#mensajeAlert p {
  margin: 0px;
}
</style>
